import React, { useEffect, useState } from "react";
import DataTable, { defaultThemes } from "react-data-table-component";
import {
  ApiGet,
  ApiDelete,
  ApiPut,
  ApiPost,
} from "../../../helpers/API/ApiData";
import { Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import Toolbar from "@material-ui/core/Toolbar";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import MapContainer from './GoogleApiWrapper';
import { getLatLongFromAddress } from './GoogleApiWrapper';
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ReactPlayer from "react-player";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import { getUserInfo } from "../../../../src/utils/user.util";
import Multiselect from "multiselect-react-dropdown";
import {
  useLoadScript,
} from "@react-google-maps/api";
import "@reach/combobox/styles.css";
import AwsConfig from "../../../config/BucketConfig/BucketConfig";
import S3 from "react-aws-s3";
import AddImage from "./AddImage";
import AddPdf from "./AddPdf";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultLocation = {
  lat: 21.170240,
  lng: 72.831062,
};

const Properties = (props) => {
  const [locationCordinatesData, setLocationCordinatesData] =
    useState(defaultLocation);
  const userInfo = getUserInfo();
  const [filteredProperties, setFilteredProperties] = useState({});
  const [selectedTopSubjects, setSelectedTopSubjects] = useState([]);
  const [dataViewMore, setDataViewMore] = useState({});
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [editQuiz, setEditQuiz] = useState([]);
  const [editPdf, setEditPdf] = useState([]);

  const [isUpdateProperties, setIsUpdateProperties] = useState(false);
  const [isAddProperties, setIsAddProperties] = useState(false);
  const [isViewMoreProperties, setIsViewMoreProperties] = useState(false);
  const [idForUpdatePropertiesData, setIdForUpdatePropertiesData] =
    useState("");
  const [allAmenities, setAllAmenities] = useState([]);
  const [aboutHome, setAboutHome] = useState("");
  const [inputValueForAdd, setInputValueForAdd] = useState({});
  const [inputValueForAddImage, setInputValueForAddImage] = useState({});
  const [inputValueForAddPdf, setInputValueForAddPdf] = useState({})
  const [inputValueForAddAdress, setInputValueForAddAdress] = useState({});
  const [errorsForAdd, setErrorsForAdd] = useState({});
  const [idForDeleteProperties, setIdForDeleteProperties] = useState("");
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [countPerPage, setCountPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [allAmenitiesForUpdate, setAllAmenitiesForUpdate] = useState([]);
  const [idForUpdatePropertyStatus, setIdForUpdatePropertyStatus] =
    useState("");
  const [statusDisplay, setStatusDisplay] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const [imageUpdate, setImageUpdate] = useState({})

  const getLatLongData = async (pincode) => {
    let latLongRes = await getLatLongFromAddress(pincode)
    if (latLongRes?.status === "OK" && latLongRes?.results?.[0]?.geometry?.location) {
      setLocationCordinatesData(latLongRes?.results?.[0]?.geometry?.location)
    } else {
      setLocationCordinatesData(defaultLocation)
    }
  }

  useEffect(() => {
    if (!isOpened && inputValueForAdd && inputValueForAdd.pincode && inputValueForAdd.pincode?.toString().length === 6) {
      getLatLongData(inputValueForAdd.pincode)
    }
    if (isUpdateProperties && !isOpened && inputValueForAddAdress && inputValueForAddAdress.pincode && inputValueForAddAdress.pincode?.toString().length === 6) {
      getLatLongData(inputValueForAddAdress.pincode)
    }
  }, [inputValueForAdd.pincode, inputValueForAddAdress.pincode])

  const handleOnChnageAdd = (e) => {
    const { name, value } = e.target;
    if (
      e.target.name === "beds" ||
      e.target.name === "baths" ||
      e.target.name === "sqft" ||
      e.target.name === "propertyTaxes" ||
      e.target.name === "cleaningFee" ||
      e.target.name === "propertyManagement" ||
      e.target.name === "maintenance" ||
      e.target.name === "utilities" ||
      e.target.name === "pacasoManagementFee" ||
      e.target.name === "insurance" ||
      e.target.name === "repairsReserve"
    ) {
      let val = e.target.value.replace(/\D/g, "");
      setInputValueForAdd({ ...inputValueForAdd, [name]: val });
      setErrorsForAdd({ ...errorsForAdd, [name]: "" });
    } else {
      const { name, value } = e.target;
      setInputValueForAdd({ ...inputValueForAdd, [name]: value });
      setErrorsForAdd({ ...errorsForAdd, [name]: "" });
    }
  };

  const handleOnChnageAddAddress = (e) => {
    const { name, value } = e.target;
    if (e.target.name === "pincode") {
      let val = e.target.value.replace(/\D/g, "");
      setInputValueForAddAdress({ ...inputValueForAddAdress, [name]: val });
      setErrorsForAdd({ ...errorsForAdd, [name]: "" });
    } else {
      const { name, value } = e.target;
      setInputValueForAddAdress({ ...inputValueForAddAdress, [name]: value });
      setErrorsForAdd({ ...errorsForAdd, [name]: "" });
    }
  };

  useEffect(() => {
    props.title === "Dashboard | OUR LEISURE HOME"
      ? (document.title = props.title)
      : (document.title = "Properties | OUR LEISURE HOME");
  }, []);

  useEffect(() =>{
    console.log("inputValueForAdd",inputValueForAdd);
  },[inputValueForAdd])

  const handleUpdatePropertyClose = () => {
    setIsUpdateProperties(false);
    setAboutHome([]);
    setInputValueForAddAdress({});
    setInputValueForAdd({});
    setSelectedTopSubjects([]);
    setErrorsForAdd({});
    setInputValueForAddImage({})
    setInputValueForAddPdf({})
  };

  const handleAddAdminClose = () => {
    setIsAddProperties(false);
    setAllAmenities([]);
    setAboutHome([]);
    setInputValueForAddAdress([]);
    setInputValueForAdd([]);
    setMarkers([]);
    setSelectedTopSubjects([]);
    setErrorsForAdd({});
    setInputValueForAddImage({})
    setInputValueForAddPdf({})
  };

  const handleViewMoreClose = () => {
    setIsViewMoreProperties(false);
    setDataViewMore({});
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleCloseShowStatus = () => {
    setShowStatus(false);
  };

  useEffect(() => {
    getAllProperties();
  }, [page, countPerPage]);

  const getAllProperties = async () => {
    setIsLoaderVisible(true);
    if (userInfo?.admin?.role === "superadmin") {
      if (!search) {
        await ApiPost(
          `property/getPropertys?page=${page}&limit=${countPerPage}`
        )
          .then((res) => {
            setIsLoaderVisible(false);
            setFilteredProperties(res?.data?.payload?.Propertys);
            setCount(res?.data?.payload?.count);
          })
          .catch((err) => {
            toast.error(err?.message);
          });
      } else {
        await ApiPost(
          `property/getPropertys?search=${search}&page=${page}&limit=${countPerPage}`
        )
          .then((res) => {
            setIsLoaderVisible(false);
            setFilteredProperties(res?.data?.payload?.Propertys);
            setCount(res?.data?.payload?.count);
          })
          .catch((err) => {
            toast.error(err?.message);
          });
      }
    } else {
      if (!search) {
        let Data = {
          aid: userInfo?.admin?.id,
        };
        await ApiPost(
          `property/getPropertys?page=${page}&limit=${countPerPage}`,
          Data
        )
          .then((res) => {
            setIsLoaderVisible(false);
            setFilteredProperties(res?.data?.payload?.Propertys);
            setCount(res?.data?.payload?.count);
          })
          .catch((err) => {
            toast.error(err?.message);
          });
      } else {
        let Data = {
          aid: userInfo?.admin?.id,
        };
        await ApiPost(
          `property/getPropertys?search=${search}&page=${page}&limit=${countPerPage}`,
          Data
        )
          .then((res) => {
            setIsLoaderVisible(false);
            setFilteredProperties(res?.data?.payload?.Propertys);
            setCount(res?.data?.payload?.count);
          })
          .catch((err) => {
            toast.error(err?.message);
          });
      }
    }
  };


  const getAmenities = () => {
    ApiGet(`amenities/getAmenities?limit=1000&type=DISTINCTIVE`)
      .then((res) => {
        if (res?.data?.payload && res?.status === 200) {
          setAllAmenities(res.data.payload?.Ameninties);
        }
      })
      .catch((err) => {
        toast.error(err?.message, { theme: "colored" });
      });
  };

  const validateFormForAddAdmin = () => {
    let formIsValid = true;
    let errorsForAdd = {};
    let filter = editQuiz.filter(e => Boolean(e.imgPath) === false);
    if (filter.length) {
      formIsValid = false;
      errorsForAdd["image"] = "*Please select image!!";
    } else if (editQuiz.length < 7) {
      formIsValid = false;
      errorsForAdd["image"] = "*minimum 7 images are required!";
    }
    if (!aboutHome) {
      formIsValid = false;
      errorsForAdd["aboutHome"] = "*Please enter about home!";
    }
    let filter1 = editPdf.filter(e => Boolean(e.pdfPath) === false);
    if (filter1.length) {
      formIsValid = false;
      errorsForAdd["document"] = "*Please select pdf!!";
    } else if (!editPdf.length) {
      formIsValid = false;
      errorsForAdd["document"] = "*pdf are required!";
    }
    if (inputValueForAdd && !inputValueForAdd.baths) {
      formIsValid = false;
      errorsForAdd["baths"] = "*Please enter number of baths!";
    }
    if (inputValueForAdd && !inputValueForAdd.ownership) {
      formIsValid = false;
      errorsForAdd["ownership"] = "*Please select ownership!";
    }
    if (inputValueForAdd && !inputValueForAdd.targetIRR) {
      formIsValid = false;
      errorsForAdd["targetIRR"] = "*Please enter target IRR!";
    }
    if (inputValueForAdd && !inputValueForAdd.rentalYield) {
      formIsValid = false;
      errorsForAdd["rentalYield"] = "*Please enter rental yield!";
    }
    if (inputValueForAdd && !inputValueForAdd.sqft) {
      formIsValid = false;
      errorsForAdd["sqft"] = "*Please enter sqft!";
    }
    if (inputValueForAdd && !inputValueForAdd.beds) {
      formIsValid = false;
      errorsForAdd["beds"] = "*Please enter number of beds!";
    }
    // if (inputValueForAdd && !inputValueForAdd.bath) {
    //   formIsValid = false;
    //   errorsForAdd["bath"] = "*Please enter number of bath!";
    // }
    if (inputValueForAdd && !inputValueForAdd.status) {
      formIsValid = false;
      errorsForAdd["status"] = "*Please select status!";
    }
    if (inputValueForAdd && !inputValueForAdd.wholeHomePrice) {
      formIsValid = false;
      errorsForAdd["wholeHomePrice"] = "*Please enter whole home price!";
    }
    if (isOpened && inputValueForAddAdress && !inputValueForAddAdress.street) {
      formIsValid = false;
      errorsForAdd["street"] = "*Please enter street name!";
    }
    if (isOpened && inputValueForAddAdress && !inputValueForAddAdress.city) {
      formIsValid = false;
      errorsForAdd["city"] = "*Please enter city name!";
    }
    if (isOpened && inputValueForAddAdress && !inputValueForAddAdress.state) {
      formIsValid = false;
      errorsForAdd["state"] = "*Please enter state name!";
    }
    if (isOpened && inputValueForAddAdress && !inputValueForAddAdress.country) {
      formIsValid = false;
      errorsForAdd["country"] = "*Please enter country name!";
    }
    if (isOpened && inputValueForAddAdress && !inputValueForAddAdress.pincode) {
      formIsValid = false;
      errorsForAdd["pincode"] = "*Please enter pincode!";
    }
    if (!isOpened && inputValueForAdd && !inputValueForAdd.street) {
      formIsValid = false;
      errorsForAdd["street"] = "*Please enter street name!";
    }
    if (!isOpened && inputValueForAdd && !inputValueForAdd.city) {
      formIsValid = false;
      errorsForAdd["city"] = "*Please enter city name!";
    }
    if (!isOpened && inputValueForAdd && !inputValueForAdd.state) {
      formIsValid = false;
      errorsForAdd["state"] = "*Please enter state name!";
    }
    if (!isOpened && inputValueForAdd && !inputValueForAdd.country) {
      formIsValid = false;
      errorsForAdd["country"] = "*Please enter country name!";
    }
    if (!isOpened && inputValueForAdd && inputValueForAdd.pincode && inputValueForAdd.pincode?.toString().length !== 6) {
      formIsValid = false;
      errorsForAdd["pincode"] = "*Please enter valid pincode!";
    }
    if (!isOpened && inputValueForAdd && !inputValueForAdd.pincode) {
      formIsValid = false;
      errorsForAdd["pincode"] = "*Please enter pincode!";
    }
    if (inputValueForAdd && !inputValueForAdd.isMapDisplay ) {
      formIsValid = false;
      errorsForAdd["isMapDisplay"] = "*Please select want to diaplay map";
    }
    if (inputValueForAdd && !inputValueForAdd.isDisplay ) {
      formIsValid = false;
      errorsForAdd["isDisplay"] = "*Please select want to diaplay Property";
    }
    if (inputValueForAdd && !inputValueForAdd.crewContact) {
      formIsValid = false;
      errorsForAdd["crewContact"] = "*Please enter phone number!";
    } else if (
      inputValueForAdd.crewContact &&
      !inputValueForAdd.crewContact.match(/^\d{10}$/)
    ) {
      formIsValid = false;
      errorsForAdd["crewContact"] = "*Please enter vaild phone number!";
    }
    if (selectedTopSubjects?.length === 0) {
      formIsValid = false;
      errorsForAdd["selectedTopSubjects"] = "*Please select amenity!";
    }
    if (formIsValid === false) {
      toast.error('Please fill required field')
    }
    setErrorsForAdd(errorsForAdd);
    return formIsValid;
  };




  const handelAddPropertyDetails = async (e) => {

    if (validateFormForAddAdmin()) {
      let pdfForAdd = await getPdfArrayFromUpload();
      let photosForAdd = await getImageArrayFromUpload();
      const newArray = [];
      {
        selectedTopSubjects.map((sub, i) => {
          newArray.push(sub._id);
        });
      }

      let Data = {
        adminid: userInfo?.admin?.id,
        // photos: photosForAdd,
        baths: inputValueForAdd?.baths,
        beds: inputValueForAdd?.beds,
        ownership: inputValueForAdd?.ownership,
        targetIRR: inputValueForAdd?.targetIRR,
        rentalYield: inputValueForAdd?.rentalYield,
        isDisplay: inputValueForAdd?.isDisplay,
        sqft: inputValueForAdd?.sqft,
        status: inputValueForAdd?.status,
        wholeHomePrice: inputValueForAdd?.wholeHomePrice,
        priceType: "Lakh",
        address: {
          street: inputValueForAdd?.street ? inputValueForAdd?.street : inputValueForAddAdress?.street,
          city: inputValueForAdd?.city ? inputValueForAdd?.city : inputValueForAddAdress?.city,
          state: inputValueForAdd?.state ? inputValueForAdd?.state : inputValueForAddAdress?.state,
          country: inputValueForAdd?.country ? inputValueForAdd?.country : inputValueForAddAdress?.country,
          pincode: inputValueForAdd?.pincode ? inputValueForAdd?.pincode : inputValueForAddAdress?.pincode,
        },
        location: {
          lat: locationCordinatesData.lat,
          lng: locationCordinatesData.lng,
        },
        isMapDisplay: inputValueForAdd.isMapDisplay,
        aboutHome: aboutHome,
        amenities: newArray,
        crewContact: inputValueForAdd.crewContact,
        property360: inputValueForAdd.property360,
        propertyVideo: inputValueForAdd.propertyVideo,
      };
      Data['photos'] = photosForAdd;
      Data['legalDocuments'] = pdfForAdd;

      await ApiPost(`property/addProperty`, Data)
        .then((res) => {
          if (res?.status == 200) {
            setIsAddProperties(false);
            toast.success("Property Added Successfully");
            setInputValueForAdd({});
            setSelectedTopSubjects([]);
            setInputValueForAddAdress({});
            setInputValueForAddImage({})
            setInputValueForAddPdf({});
            setAboutHome("");
            setMarkers([]);
            getAllProperties();
            {
              document.title === "Dashboard | OUR LEISURE HOME" &&
                props.getNewCount();
            }
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };


  const uploadS3bucket = async (file) => {
    let config = AwsConfig;
    config = {
      ...config,
      dirName: "Cerificate",
      ACL: "public-read",

    };
    const Reacts3Client = new S3(config);
    let urls;
    let f = file;

    let filename = "AboutImage(" + new Date().getTime() + ")";
    let data = await Reacts3Client.uploadFile(f, filename);
    urls = data.location;
    return urls
  }


  const getImageArrayFromUpload = async () => {

    let file = editQuiz;

    let photos = []
    for (let i = 0; i < file?.length; i++) {
      if (typeof file[i].imgPath === 'string') {
        photos.push({ imgPath: file[i].imgPath })
      } else {
        let driviniglicencephoto = await uploadS3bucket(file[i].imgPath);
        photos.push({ imgPath: driviniglicencephoto })

      }
    }
    return photos;
  };

  const getPdfArrayFromUpload = async (e) => {
    let file = editPdf;

    let legalDocuments = []
    for (let i = 0; i < file?.length; i++) {
      if (typeof file[i].pdfPath === 'string') {
        legalDocuments.push({ pdfPath: file[i].pdfPath })
      } else {
        let driviniglicencephoto = await uploadS3bucket(file[i].pdfPath);
        legalDocuments.push({ pdfPath: driviniglicencephoto })

      }
    }
    return legalDocuments;
  };


  const validateForm = () => {
    let formIsValid = true;
    let errorsForAdd = {};
    let filter = editQuiz.filter(e => Boolean(e.imgPath) === false);
    if (filter.length) {
      formIsValid = false;
      errorsForAdd["image"] = "*Please select image!!";
    } else if (editQuiz.length < 7) {
      formIsValid = false;
      errorsForAdd["image"] = "*minimum 7 images are required!";
    }
    let filter1 = editPdf.filter(e => Boolean(e.pdfPath) === false);
    if (filter1.length) {
      formIsValid = false;
      errorsForAdd["document"] = "*Please select pdf!!";
    } else if (!editPdf.length) {
      formIsValid = false;
      errorsForAdd["document"] = "*pdf are required!";
    }
    if (inputValueForAdd && !inputValueForAdd.baths) {
      formIsValid = false;
      errorsForAdd["baths"] = "*Please enter number of baths!";
    }
    if (!inputValueForAddImage) {
      formIsValid = false;
      errorsForAdd["photos"] = "*Please add image!";
    }
    if (inputValueForAdd && !inputValueForAdd.beds) {
      formIsValid = false;
      errorsForAdd["beds"] = "*Please enter number of beds!";
    }
    if (inputValueForAdd && !inputValueForAdd.ownership) {
      formIsValid = false;
      errorsForAdd["ownership"] = "*Please enter ownership!";
    }
    if (inputValueForAdd && !inputValueForAdd.targetIRR) {
      formIsValid = false;
      errorsForAdd["targetIRR"] = "*Please enter target IRR!";
    }
    if (inputValueForAdd && !inputValueForAdd.rentalYield) {
      formIsValid = false;
      errorsForAdd["rentalYield"] = "*Please enter rental yield!";
    }
    if (inputValueForAdd && !inputValueForAdd.sqft) {
      formIsValid = false;
      errorsForAdd["sqft"] = "*Please enter sqft!";
    }
    if (inputValueForAdd && !inputValueForAdd.status) {
      formIsValid = false;
      errorsForAdd["status"] = "*Please Select status!";
    }
    if (inputValueForAdd && !inputValueForAdd.wholeHomePrice) {
      formIsValid = false;
      errorsForAdd["wholeHomePrice"] = "*Please enter whole home price!";
    }
    if (inputValueForAddAdress && !inputValueForAddAdress.street) {
      formIsValid = false;
      errorsForAdd["street"] = "*Please enter street name!";
    }
    if (inputValueForAddAdress && !inputValueForAddAdress.city) {
      formIsValid = false;
      errorsForAdd["city"] = "*Please enter city name!";
    }
    if (inputValueForAddAdress && !inputValueForAddAdress.state) {
      formIsValid = false;
      errorsForAdd["state"] = "*Please enter state name!";
    }
    if (inputValueForAddAdress && !inputValueForAddAdress.country) {
      formIsValid = false;
      errorsForAdd["country"] = "*Please enter country name!";
    }
    if (inputValueForAddAdress && !inputValueForAddAdress.pincode) {
      formIsValid = false;
      errorsForAdd["pincode"] = "*Please enter pincode!";
    }
    if (inputValueForAdd && !inputValueForAdd.isMapDisplay) {
      formIsValid = false;
      errorsForAdd["isMapDisplay"] = "*Please select want to diaplay map";
    }
    if (inputValueForAdd && !inputValueForAdd.isDisplay) {
      formIsValid = false;
      errorsForAdd["isDisplay"] = "*Please select want to diaplay Property";
    }
    if (!aboutHome) {
      formIsValid = false;
      errorsForAdd["aboutHome"] = "*Please enter about Home!";
    }
    if (inputValueForAdd && !inputValueForAdd.crewContact) {
      formIsValid = false;
      errorsForAdd["crewContact"] = "*Please enter Phone Number!";
    } else if (
      inputValueForAdd.crewContact &&
      !inputValueForAdd.crewContact.match(/^\d{10}$/)
    ) {
      formIsValid = false;
      errorsForAdd["crewContact"] = "*Please enter vaild phone number!";
    }
    if (selectedTopSubjects?.length === 0) {
      formIsValid = false;
      errorsForAdd["selectedTopSubjects"] = "*Please select amenity!";
    }
    if (formIsValid === false) {
      toast.error('Please fill required field')
    }
    setErrorsForAdd(errorsForAdd);
    return formIsValid;
  };

  const handelUpdatePropertyDetails = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      let photosForAdd = await getImageArrayFromUpload();
      let pdfForAdd = await getPdfArrayFromUpload();
      const newArray = [];
      {
        selectedTopSubjects.map((sub, i) => {
          newArray.push(sub._id);
        });
      }
      let Data = {
        adminid: userInfo?.admin?.id,
        baths: inputValueForAdd?.baths,
        beds: inputValueForAdd?.beds,
        ownership: inputValueForAdd?.ownership,
        targetIRR: inputValueForAdd?.targetIRR,
        rentalYield: inputValueForAdd?.rentalYield,
        isDisplay: inputValueForAdd?.isDisplay,
        sqft: inputValueForAdd?.sqft,
        status: inputValueForAdd?.status,
        wholeHomePrice: inputValueForAdd?.wholeHomePrice,
        // priceType: inputValueForAdd?.priceType,
        priceType: "Lakh",
        address: {
          street: inputValueForAdd?.street ? inputValueForAdd?.street : inputValueForAddAdress?.street,
          city: inputValueForAdd?.city ? inputValueForAdd?.city : inputValueForAddAdress?.city,
          state: inputValueForAdd?.state ? inputValueForAdd?.state : inputValueForAddAdress?.state,
          country: inputValueForAdd?.country ? inputValueForAdd?.country : inputValueForAddAdress?.country,
          pincode: inputValueForAdd?.pincode ? inputValueForAdd?.pincode : inputValueForAddAdress?.pincode,
        },
        location: {
          lat: locationCordinatesData.lat,
          lng: locationCordinatesData.lng,
        },
        isMapDisplay: inputValueForAdd.isMapDisplay,
        aboutHome: aboutHome,
        amenities: newArray,
        crewContact: inputValueForAdd.crewContact,
        propertyVideo: inputValueForAdd.propertyVideo,
      };
      Data['photos'] = photosForAdd;
      Data['legalDocuments'] = pdfForAdd;
      ApiPut(`property/updateProperty/${idForUpdatePropertiesData}`, Data)
        .then((res) => {
          if (res?.status === 200) {
            setIsUpdateProperties(false);
            toast.success("Data updated Successfully");
            getAllProperties();
            setAboutHome([]);
            setInputValueForAddAdress({});
            setInputValueForAdd({});
            setMarkers([]);
            setSelectedTopSubjects([]);
            setErrorsForAdd({});
            setAllAmenities([]);
            setAllAmenitiesForUpdate([]);
            setInputValueForAddImage({});
            setInputValueForAddPdf({})
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };
  const handleUpdateStatusProperty = (status) => {
    ApiPut(`property/updateStatus/${idForUpdatePropertyStatus}`, {
      isDisplay: status,
    })
      .then((res) => {
        if (res?.status === 200) {
          setShowStatus(false);
          toast.success("Status updated Successfully");
          getAllProperties();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleDeleteProperty = () => {
    ApiDelete(`property/deleteProperty/${idForDeleteProperties}`)
      .then((res) => {
        if (res?.status === 200) {
          setShow(false);
          toast.success("Property Deleted Successfully");
          getAllProperties();
          {
            document.title === "Dashboard | OUR LEISURE HOME" && props.getNewCount();
          }
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const columns = [
    {
      name: "SNo",
      cell: (row, index) => (page - 1) * countPerPage + (index + 1),
      width: "65px",
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
    {
      name: "WholeHome Price",
      cell: (row) => {
        return (
          <>
            {row?.wholeHomePrice}{" "}
            {row?.priceType}
          </>
        )
      }
    },
    {
      name: "Baths",
      selector: "baths",
      sortable: true,
    },
    {
      name: "Beds",
      selector: "beds",
      sortable: true,
    },
    {
      name: "Sqft",
      selector: "sqft",
      sortable: true,
    },
    {
      name: "Display?",
      cell: (row) => {
        return (
          <>
            <div
              className="cursor-pointer"
              onClick={() => {
                setShowStatus(true);
                setIdForUpdatePropertyStatus(row?._id);
                setStatusDisplay(row?.isDisplay);
              }}
            >
              <Tooltip title="Status Property" arrow>
                <div className="cus-medium-button-style">
                  <button>
                    {row?.isDisplay === true ? "Active" : "Deactive"}
                  </button>
                </div>
              </Tooltip>
            </div>
          </>
        );
      },
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between">
              <div
                className="cursor-pointer pl-2"
                onClick={() => {
                  getAmenities();
                  setIsUpdateProperties(true);
                  setDataViewMore(row);
                  setEditQuiz(row?.photos)
                  setEditPdf(row?.legalDocuments)
                  setIdForUpdatePropertiesData(row._id);
                  setInputValueForAdd({
                    adminid: userInfo?.admin?.id,
                    baths: row?.baths,
                    beds: row?.beds,
                    ownership: row?.ownership,
                    targetIRR: row?.targetIRR,
                    rentalYield: row?.rentalYield,
                    homeUpgradePrice: row?.homeUpgradePrice,
                    isDisplay: row?.isDisplay,
                    isMapDisplay: row?.isMapDisplay,
                    shareStatus: row?.shareStatus,
                    sqft: row?.sqft,
                    status: row?.status,
                    wholeHomePrice: row?.wholeHomePrice,
                    priceType: row?.priceType,
                    cleaningFee: row?.monthlyExpenses?.cleaningFee,
                    crewContact: row?.crewContact,
                    insurance: row?.monthlyExpenses?.insurance,
                    maintenance: row?.monthlyExpenses?.maintenance,
                    pacasoManagementFee:
                      row?.monthlyExpenses?.pacasoManagementFee,
                    property360: row?.property360,
                    propertyManagement:
                      row?.monthlyExpenses?.propertyManagement,
                    propertyTaxes: row?.monthlyExpenses?.propertyTaxes,
                    propertyVideo: row?.propertyVideo,
                    repairsReserve: row?.monthlyExpenses?.repairsReserve,
                    utilities: row?.monthlyExpenses?.utilities,
                  });
                  setImageUpdate(row?.photos)
                  setInputValueForAddPdf(row?.legalDocuments?.pdfPath)
                  setInputValueForAddAdress({
                    street: row?.address?.street,
                    city: row?.address?.city,
                    state: row?.address?.state,
                    country: row?.address?.country,
                    pincode: row?.address?.pincode,
                  });
                  setAboutHome(row?.aboutHome);
                  setAllAmenitiesForUpdate(row?.amenities);
                  setMarkers([
                    {
                      lat: row?.location?.coordinates[1],
                      lng: row?.location?.coordinates[0],
                    },
                  ]);
                  setLocationCordinatesData({
                    lat: row?.location?.coordinates[1],
                    lng: row?.location?.coordinates[0],
                  })
                  setSelectedTopSubjects(row?.amenities);
                }}
              >
                <Tooltip title="Edit Property" arrow>
                  <CreateIcon />
                </Tooltip>
              </div>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => {
                setShow(true);
                setIdForDeleteProperties(row?._id);
              }}
            >
              <Tooltip title="Delete Ameninties" arrow>
                <DeleteIcon />
              </Tooltip>
            </div>
            <div
              className="cursor-pointer pl-2"
              onClick={() => {
                setIsViewMoreProperties(true);
                setDataViewMore(row);
              }}
            >
              <Tooltip title="Show More" arrow>
                <InfoOutlinedIcon />
              </Tooltip>
            </div>
          </>
        );
      },
    },
  ];

  const columns5 = [
    {
      name: "SNo",
      width: "80px",
      cell: (row, index) => index + 1,
    },
    {
      name: "Image",
      width: "80px",
      cell: (row) => {
        return (
          <>
            <div className="p-3">
              <img
                className="max-w-50px zoom"
                alt="img"
                src={row?.imgPath != null ? row.imgPath : ""}
              />
            </div>
          </>
        );
      },
      wrap: true,
    },
  ];
  const columns1 = [
    {
      name: "SNo",
      cell: (row, index) => index + 1,
    },
    {
      name: "Amenitie Name",
      selector: "name",
      sortable: true,
    },
    {
      name: "Amenitie Type",
      selector: "type",
      sortable: true,
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);
  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(
      () => {
        const handler = setTimeout(() => {
          setDebouncedValue(value);
        }, delay);
        return () => {
          clearTimeout(handler);
        };
      },
      [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
  }

  useEffect(() => {
    if (debouncedSearchTerm) {
      setIsLoaderVisible(true);
      setPage(1);
      setCount(0);
      setCountPerPage(countPerPage);
      getAllProperties();
    } else {
      setPage(1);
      setCount(0);
      setCountPerPage(countPerPage);
      getAllProperties();
    }
  }, [debouncedSearchTerm]);

  //for map integration

  const libraries = ["places"];

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
    libraries,
  });

  const getLatLag = React.useCallback((data) => {
    var stateCopy = Object.assign({});

    let cordinatesData = {
      lng: data.latlng && data.latlng.lng,
      lat: data.latlng && data.latlng.lat,
    };
    stateCopy.address = data.address;
    stateCopy.buildingNo = data.streetNumber;
    stateCopy.country = data.country;
    stateCopy.state = data.province;
    stateCopy.city = data.city;
    stateCopy.zipCode = data.ZipCode;
    let bodyAddress = {
      street: data?.address,
      city: data.city,
      state: data.province,
      country: data.country,
      pincode: data.ZipCode,
    };
    setLocationCordinatesData(cordinatesData);
    setInputValueForAddAdress({ ...bodyAddress })
  }, []);




  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";


  function toggle() {
    setIsOpened(wasOpened => !wasOpened);
  }

  return (
    <>
      <div className="card p-1">
        <ToastContainer />
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3">
            <div className="col-md-3 col-sm-12 d-flex justify-content-between">
              <h2 className="pl-3 pt-2">Properties Listing</h2>
            </div>
            <div className="col-md-7 col-sm-12 mobile-view-align">
              <div>
                <input
                  type="text"
                  className={`form-control form-control-lg form-control-solid `}
                  name="title"
                  placeholder="Search Properties"
                  onChange={(e) => handleSearch(e)}
                />
              </div>
            </div>
            <div className="col-md-2 cus-medium-button-style button-height mobile-button-center-align mobile-view-align">
              {/* <NavLink to="/property/addProperty" className="text-white"> */}
              <button
                onClick={() => {
                  setIsAddProperties(true);
                  getAmenities();
                }}
              >
                Add Property
              </button>
            </div>
          </div>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title className="text-danger">Alert!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are You Sure To Want To delete this Amenintie
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                cancel
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  handleDeleteProperty();
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
          {/* end delete model */}

          {/* Status model */}
          <Modal show={showStatus} onHide={handleCloseShowStatus}>
            <Modal.Header closeButton>
              <Modal.Title className="text-danger">Alert!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are You Sure To Want To{" "}
              {statusDisplay === true ? "De-active" : "Active"} this Amenintie
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseShowStatus}>
                cancel
              </Button>
              <Button
                variant="danger"
                onClick={(e) => {
                  handleUpdateStatusProperty(!statusDisplay);
                }}
              >
                {statusDisplay === true ? "De-active" : "Active"}
              </Button>
            </Modal.Footer>
          </Modal>
          <DataTable
            columns={columns}
            data={filteredProperties}
            customStyles={customStyles}
            style={{
              marginTop: "-3rem",
              marginRight: "-3rem",
            }}
            progressPending={isLoaderVisible}
            progressComponent={
              <Loader type="Puff" color="#334D52" height={30} width={30} />
            }
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[10, 20, 25, 50, 100]}
            paginationDefaultPage={page}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
          />
        </div>
      </div>
      {isAddProperties ? (
        <Dialog
          fullScreen
          open={isAddProperties}
          onClose={handleAddAdminClose}
          TransitionComponent={Transition}
        >
          <div className="cus-modal-close" onClick={handleAddAdminClose}>
            <CloseIcon />
          </div>
          <List>
            {isAddProperties === true ? (
              <div className="all-content-alignment-properties">

                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Status
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="status"
                      name="status"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option value="" disabled selected hidden>
                        Select Starus Of Property
                      </option>
                      <option value="Available Now">Available Now</option>
                      <option value="Prospect">Prospect</option>
                    </select>

                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["status"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Ownership
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="ownership"
                      name="ownership"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option value="" disabled selected hidden>
                        Select ownership
                      </option>
                      <option value="1/4">1/4</option>
                      <option value="2/4">2/4</option>
                      <option value="3/4">3/4</option>
                    </select>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["ownership"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Want To Display?
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="isDisplay"
                      name="isDisplay"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option value="" disabled selected hidden>
                        what you want Display or hide please select?
                      </option>
                      <option value={true}>Display</option>
                      <option value={false}>Hide</option>
                    </select>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["isDisplay"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Whole Home Price
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div className="number-input-grid">
                      <div>
                        <input
                          type="number"
                          className={`form-control form-control-lg form-control-solid `}
                          id="wholeHomePrice"
                          name="wholeHomePrice"
                          onChange={(e) => {
                            handleOnChnageAdd(e);
                          }}
                          onKeyDown={(evt) =>
                            evt.key === "e" || evt.key === "-" && evt.preventDefault()
                          }
                          min="0"
                          maxlength={10}
                          onInput={(e) => {
                            // append 0 if first character is .
                            if (e.target.value[0] === ".") e.target.value = parseFloat("0.").toString()
                              .slice(0, 10) + e.target.value.toString()
                                .slice(0, 10);
                          }}
                          value={inputValueForAdd.wholeHomePrice}
                        /> </div>

                      <div>
                        <div
                          id="priceType"
                          name="priceType"
                          className={`form-control form-control-lg form-control-solid `}
                          onChange={(e) => handleOnChnageAdd(e)}
                        >
                          {/* <option value="" disabled selected hidden>
                            Seclect Value
                          </option> */}
                          <span >Lakh</span>
                          {/* <option value="Crore">Crore</option> */}
                        </div>
                      </div>
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["wholeHomePrice"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Target IRR (%)
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="targetIRR"
                        name="targetIRR"
                        value={inputValueForAdd.targetIRR}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                        onKeyDown={(evt) =>
                          evt.key === "e" || evt.key === "-" && evt.preventDefault()
                        }
                        min="0"
                        maxlength={10}
                        onInput={(e) => {
                          // append 0 if first character is .
                          if (e.target.value[0] === ".") e.target.value = parseFloat("0.").toString()
                            .slice(0, 10) + e.target.value.toString()
                              .slice(0, 10);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["targetIRR"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Rental Yield (%)
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="rentalYield"
                        name="rentalYield"
                        value={inputValueForAdd.rentalYield}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                        onKeyDown={(evt) =>
                          evt.key === "e" || evt.key === "-" && evt.preventDefault()
                        }
                        min="0"
                        maxlength={10}
                        onInput={(e) => {
                          // append 0 if first character is .
                          if (e.target.value[0] === ".") e.target.value = parseFloat("0.").toString()
                            .slice(0, 10) + e.target.value.toString()
                              .slice(0, 10);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["rentalYield"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Number Of Beds
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="beds"
                        name="beds"
                        value={inputValueForAdd.beds}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["beds"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Number Of Baths
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="baths"
                        name="baths"
                        value={inputValueForAdd.baths}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["baths"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Property Image
                  </label>
                  <div className="col-lg-9 col-xl-6">

                    <AddImage accept={"image/*"} getCourses={(courses) => setEditQuiz(courses)} />
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["image"]}
                    </span>

                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Legal Documents
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <AddPdf accept="*" getCourses={(courses) => setEditPdf(courses)} />
                      <span
                        style={{
                          color: "red",
                          top: "5px",
                          fontSize: "12px",
                        }}
                      >
                        {errorsForAdd["document"]}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Home sqft
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="sqft"
                        name="sqft"
                        value={inputValueForAdd.sqft}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["sqft"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Enter Location
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    {isOpened && isOpened ?
                      <button className="select-location-button" onClick={toggle}>
                        Enter manualy Location
                      </button>
                      :
                      <button className="select-location-button" onClick={toggle}>
                        Select Location
                      </button>
                    }
                  </div>
                </div>
                {isOpened &&
                  <>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Enter Location
                      </label>
                    </div>
                    <div className="form-group">
                      <MapContainer
                        autocomplete
                        onMarkerPosChanged={(
                          data
                        ) => {
                          getLatLag(data)
                        }}
                        google={
                          props.google
                        }
                        center={
                          locationCordinatesData
                        }
                        height="400px"
                        zoom={15}
                      />
                    </div>
                  </>
                }
                {isOpened &&
                  <>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Street
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            type="text"
                            className={`form-control form-control-lg form-control-solid `}
                            id="street"
                            name="street"
                            value={inputValueForAddAdress.street}
                            onChange={(e) => {
                              handleOnChnageAddAddress(e);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["street"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        City
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <input
                          id="city"
                          name="city"
                          className={`form-control form-control-lg form-control-solid `}
                          onChange={(e) => handleOnChnageAddAddress(e)}
                          value={inputValueForAddAdress.city}
                        >
                        </input>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["city"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        State
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <input
                          id="state"
                          name="state"
                          className={`form-control form-control-lg form-control-solid `}
                          onChange={(e) => handleOnChnageAddAddress(e)}
                          value={inputValueForAddAdress.state}
                        >
                        </input>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["state"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Country
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            id="country"
                            name="country"
                            className={`form-control form-control-lg form-control-solid `}
                            onChange={(e) => handleOnChnageAddAddress(e)}
                            value={inputValueForAddAdress.country}
                          >
                          </input>
                        </div>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["country"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Pincode
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            type="number"
                            className={`form-control form-control-lg form-control-solid `}
                            id="pincode"
                            name="pincode"
                            value={inputValueForAddAdress.pincode}
                            onChange={(e) => {
                              handleOnChnageAddAddress(e);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["pincode"]}
                        </span>
                      </div>
                    </div>
                  </>}

                {!isOpened &&

                  <>


                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Street
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            type="text"
                            className={`form-control form-control-lg form-control-solid `}
                            id="street"
                            name="street"
                            value={inputValueForAdd.street}
                            onChange={(e) => {
                              handleOnChnageAdd(e);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["street"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        City
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <input
                          id="city"
                          name="city"
                          className={`form-control form-control-lg form-control-solid `}
                          onChange={(e) => handleOnChnageAdd(e)}
                          value={inputValueForAdd.city}
                        >
                        </input>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["city"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        State
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <input
                          id="state"
                          name="state"
                          className={`form-control form-control-lg form-control-solid `}
                          onChange={(e) => handleOnChnageAdd(e)}
                          value={inputValueForAdd.state}
                        >
                        </input>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["state"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Country
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            id="country"
                            name="country"
                            className={`form-control form-control-lg form-control-solid `}
                            onChange={(e) => handleOnChnageAdd(e)}
                            value={inputValueForAdd.country}
                          >
                          </input>
                        </div>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["country"]}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Pincode
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <div>
                          <input
                            type="number"
                            className={`form-control form-control-lg form-control-solid `}
                            id="pincode"
                            name="pincode"
                            value={inputValueForAdd.pincode}
                            onChange={(e) => {
                              handleOnChnageAdd(e);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errorsForAdd["pincode"]}
                        </span>
                      </div>
                    </div>
                  </>
                }
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errorsForAdd["markers"]}
                </span>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Want To Display Map?
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="isMapDisplay"
                      name="isMapDisplay"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option value="" disabled selected hidden>
                        you want display map or hide please select?
                      </option>
                      <option value={true}>Display</option>
                      <option value={false}>Hide</option>
                    </select>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["isMapDisplay"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    About Home
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <CKEditor
                      editor={ClassicEditor}
                      data={aboutHome}
                      value={inputValueForAdd.aboutHome}
                      onChange={(aboutHomeData, editor) => {
                        setAboutHome(editor.getData());
                        setErrorsForAdd({ ...errorsForAdd, aboutHome: "" });
                      }}
                    />
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["aboutHome"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Select Ameninties
                  </label>

                  <div className="col-lg-9 col-xl-6">
                    <Multiselect
                      options={allAmenities}
                      onSelect={(selectedList, selectedItem) => {
                        setSelectedTopSubjects(selectedList);
                        setErrorsForAdd({
                          ...errorsForAdd,
                          selectedTopSubjects: "",
                        });
                      }}
                      onRemove={(selectedList, removedItem) => {
                        setSelectedTopSubjects(selectedList);
                      }}
                      displayValue="name"
                    />

                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["selectedTopSubjects"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Crew Contact
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="crewContact"
                        name="crewContact"
                        value={inputValueForAdd.crewContact}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["crewContact"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Video Of Property
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="propertyVideo"
                        name="propertyVideo"
                        value={inputValueForAdd.propertyVideo}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["propertyVideo"]}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    onClick={(e) => {
                      handelAddPropertyDetails(e);
                    }}
                    className="btn btn-success mr-2"
                  >
                    <span>Add Details</span>
                    {loading && (
                      <span className="mx-3 spinner spinner-white"></span>
                    )}
                  </button>
                </div>
              </div>
            ) : null}
          </List>
        </Dialog>
      ) : null}

      {isViewMoreProperties ? (
        <Dialog
          fullScreen
          open={isViewMoreProperties}
          onClose={handleViewMoreClose}
          TransitionComponent={Transition}
        >
          <div className="cus-modal-close" onClick={handleViewMoreClose}>
            <CloseIcon />
          </div>
          <List>
            {isViewMoreProperties === true ? (
              <div className="form full-container">
                <div className="form-group row">
                  <p>{`Status: ${dataViewMore?.status}`}</p>
                </div>
                <div className="form-group row">
                  <p>{`ownership status: ${dataViewMore?.ownership}`}</p>
                </div>
                <div className="form-group row">
                  <p>{`rentalYield: ${dataViewMore?.rentalYield}`}</p>
                </div>
                <div className="form-group row">
                  <p>{`targetIRR: ${dataViewMore?.targetIRR}`}</p>
                </div>
                <div className="form-group row">
                  <p>{`Whole Home Price: ${dataViewMore?.wholeHomePrice} ${dataViewMore?.priceType} `}</p>
                </div>
                <div className="form-group row">
                  <p>{`sqft: ${dataViewMore?.sqft}`}</p>
                </div>
                <div className="form-group row mb-0">
                  <p>Property Image</p>
                </div>
                <div className="form-group row mr-20">
                  <DataTable
                    columns={columns5}
                    data={dataViewMore?.photos}
                    customStyles={customStyles}
                    style={{
                      marginTop: "-4rem",
                    }}
                    progressPending={isLoaderVisible}
                    progressComponent={
                      <Loader
                        type="Puff"
                        color="#334D52"
                        height={30}
                        width={30}
                      />
                    }
                    highlightOnHover
                  />
                </div>
                <div className="form-group row">
                  <p>{`Number of Baths: ${dataViewMore?.baths}`}</p>
                </div>
                <div className="form-group row">
                  <p>{`Number of Beds: ${dataViewMore?.beds}`}</p>
                </div>
                <div className="form-group row">
                  <p>{`Crew Contact No.: ${dataViewMore?.crewContact}`}</p>
                </div>
                <div className="form-group row mb-0">
                  <p>Adress</p>
                </div>
                <p>{`City: ${dataViewMore?.address?.city}`}</p>
                <p>{`Country: ${dataViewMore?.address?.country}`}</p>
                <p>{`Pincode: ${dataViewMore?.address?.pincode}`}</p>
                <p>{`State: ${dataViewMore?.address?.state}`}</p>
                <p>{`Street: ${dataViewMore?.address?.street}`}</p>
                <div className="form-group row mb-0">
                  <p>About Home</p>
                </div>
                <div className="form-group row mr-20">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: dataViewMore?.aboutHome,
                    }}
                    className=""
                  />
                </div>
                <div className="form-group row mb-0">
                  <p>Amenities</p>
                </div>
                <div className="form-group row mr-20">
                  <DataTable
                    columns={columns1}
                    data={dataViewMore?.amenities}
                    customStyles={customStyles}
                    style={{
                      marginTop: "-4rem",
                    }}
                    progressPending={isLoaderVisible}
                    progressComponent={
                      <Loader
                        type="Puff"
                        color="#334D52"
                        height={30}
                        width={30}
                      />
                    }
                    highlightOnHover
                  />
                </div>
                <div className="form-group row mb-0">
                  {dataViewMore?.propertyVideo && (
                    <ReactPlayer
                      url={dataViewMore?.propertyVideo}
                      playing={false}
                      controls={true}
                    />
                  )}
                </div>
                <div className="form-group row mb-0">
                  <iframe
                    width="540"
                    height="450"
                    src={`https://maps.google.com/maps?q=${dataViewMore?.location?.coordinates[1]},${dataViewMore?.location?.coordinates[0]}&output=embed`}
                  ></iframe>
                </div>
              </div>
            ) : null}
          </List>
        </Dialog>
      ) : null}

      {isUpdateProperties ? (
        <Dialog
          fullScreen
          open={isUpdateProperties}
          onClose={handleUpdatePropertyClose}
          TransitionComponent={Transition}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleUpdatePropertyClose}
              aria-label="close"
              style={{ width: '100%', justifyContent: 'flex-end' }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <List>
            {isUpdateProperties === true ? (
              <div className="all-content-alignment-properties">
                {/* Status */}
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Status
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="status"
                      name="status"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option
                        value="Available Now"
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.status === "Available Now"
                            ? true
                            : false
                        }
                      >
                        Available Now
                      </option>
                      <option
                        value="Prospect"
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.status === "Prospect"
                            ? true
                            : false
                        }
                      >
                        Prospect
                      </option>
                    </select>

                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["status"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Ownership
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="ownership"
                      name="ownership"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option value="" disabled selected hidden>
                        Select ownership
                      </option>
                      <option
                        value="1/4"
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.ownership === "1/4"
                            ? true
                            : false
                        }
                      >
                        1/4
                      </option>
                      <option
                        value="2/4"
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.ownership === "2/4"
                            ? true
                            : false
                        }
                      >
                        2/4
                      </option>
                      <option
                        value="3/4"
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.ownership === "3/4"
                            ? true
                            : false
                        }
                      >
                        3/4
                      </option>
                    </select>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["ownership"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Want To Display?
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="isDisplay"
                      name="isDisplay"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option
                        value={true}
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.isDisplay === true
                            ? true
                            : false
                        }
                      >
                        Display
                      </option>
                      <option
                        value={false}
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.isDisplay === false
                            ? true
                            : false
                        }
                      >
                        Hide
                      </option>
                    </select>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["isDisplay"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Whole Home Price
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div className="number-input-grid">
                      <div>
                        <input
                          type="number"
                          className={`form-control form-control-lg form-control-solid `}
                          id="wholeHomePrice"
                          name="wholeHomePrice"
                          value={inputValueForAdd.wholeHomePrice}
                          onChange={(e) => {
                            handleOnChnageAdd(e);
                          }}
                          onKeyDown={(evt) =>
                            evt.key === "e" || evt.key === "-" && evt.preventDefault()
                          }
                          min="0"
                          maxlength={10}
                          onInput={(e) => {
                            // append 0 if first character is .
                            if (e.target.value[0] === ".") e.target.value = parseFloat("0.").toString()
                              .slice(0, 10) + e.target.value.toString()
                                .slice(0, 10);
                          }}
                        />
                      </div>
                      <div>
                        <div
                          id="priceType"
                          name="priceType"
                          className={`form-control form-control-lg form-control-solid `}
                          onChange={(e) => handleOnChnageAdd(e)}
                        >
                          <span >Lakh</span>
                          {/* <span value="Lakh" selected={inputValueForAdd && inputValueForAdd?.priceType === "Lakh" ? true : false}>Lakh</span> */}
                          {/* <option value="Crore" selected={inputValueForAdd && inputValueForAdd?.priceType === "Crore" ? true : false}>Crore</option> */}
                        </div>
                      </div>
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["wholeHomePrice"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Target IRR (%)
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="targetIRR"
                        name="targetIRR"
                        value={inputValueForAdd.targetIRR}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                        onKeyDown={(evt) =>
                          evt.key === "e" || evt.key === "-" && evt.preventDefault()
                        }
                        min="0"
                        maxlength={10}
                        onInput={(e) => {
                          // append 0 if first character is .
                          if (e.target.value[0] === ".") e.target.value = parseFloat("0.").toString()
                            .slice(0, 10) + e.target.value.toString()
                              .slice(0, 10);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["targetIRR"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Rental Yield (%)
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="rentalYield"
                        name="rentalYield"
                        value={inputValueForAdd.rentalYield}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                        onKeyDown={(evt) =>
                          evt.key === "e" || evt.key === "-" && evt.preventDefault()
                        }
                        min="0"
                        maxlength={10}
                        onInput={(e) => {
                          // append 0 if first character is .
                          if (e.target.value[0] === ".") e.target.value = parseFloat("0.").toString()
                            .slice(0, 10) + e.target.value.toString()
                              .slice(0, 10);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["rentalYield"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Number Of Beds
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="beds"
                        name="beds"
                        value={inputValueForAdd.beds}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["beds"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Property Image
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <AddImage coursesEdit={editQuiz} accept='image/*' getCourses={(courses) => setEditQuiz(courses)} />
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["image"]}
                    </span>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Legal Documents
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <AddPdf coursesEdit={editPdf} accept='*' getCourses={(courses) => setEditPdf(courses)} />
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["document"]}
                    </span>
                  </div>
                </div>

                {/* <div className="form-group row mr-20">
                  <DataTable
                    columns={columns5}
                    data={dataViewMore?.photos}
                    customStyles={customStyles}
                    style={{
                      marginTop: "-4rem",
                    }}
                    progressPending={isLoaderVisible}
                    progressComponent={
                      <Loader
                        type="Puff"
                        color="#334D52"
                        height={30}
                        width={30}
                      />
                    }
                    highlightOnHover
                  />
                </div> */}
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Home sqft
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="sqft"
                        name="sqft"
                        value={inputValueForAdd.sqft}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["sqft"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Enter Location
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    {isOpened && isOpened ?
                      <button className="select-location-button" onClick={toggle}>
                        Enter manualy Location
                      </button>
                      :
                      <button className="select-location-button" onClick={toggle}>
                        Select Location
                      </button>
                    }
                  </div>
                </div>
                {isOpened &&
                  <>
                    <div className="form-group row">
                      <label className="col-xl-3 col-lg-3 col-form-label">
                        Enter Location
                      </label>
                    </div>
                    <div className="form-group">
                      <MapContainer
                        autocomplete
                        onMarkerPosChanged={(
                          data
                        ) => {
                          getLatLag(data)
                        }}
                        google={
                          props.google
                        }
                        center={
                          locationCordinatesData
                        }
                        height="400px"
                        zoom={15}
                      />
                    </div>
                  </>
                }
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Street
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="street"
                        name="street"
                        value={inputValueForAddAdress.street}
                        onChange={(e) => {
                          handleOnChnageAddAddress(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["street"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    City
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <input
                      id="city"
                      name="city"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAddAddress(e)}
                      value={inputValueForAddAdress.city}
                    >
                    </input>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["city"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    State
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <input
                      id="state"
                      name="state"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAddAddress(e)}
                      value={inputValueForAddAdress.state}
                    >
                    </input>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["state"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Country
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        id="country"
                        name="country"
                        className={`form-control form-control-lg form-control-solid `}
                        onChange={(e) => handleOnChnageAddAddress(e)}
                        value={inputValueForAddAdress.country}
                      >

                      </input>
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["country"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Pincode
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="pincode"
                        name="pincode"
                        value={inputValueForAddAdress.pincode}
                        onChange={(e) => {
                          handleOnChnageAddAddress(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["pincode"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Want To Display Map?
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      id="isMapDisplay"
                      name="isMapDisplay"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => handleOnChnageAdd(e)}
                    >
                      <option
                        value={true}
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.isMapDisplay === true
                            ? true
                            : false
                        }
                      >
                        Display
                      </option>
                      <option
                        value={false}
                        selected={
                          inputValueForAdd &&
                            inputValueForAdd?.isMapDisplay === false
                            ? true
                            : false
                        }
                      >
                        Hide
                      </option>
                    </select>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["isMapDisplay"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    About Home
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <CKEditor
                      editor={ClassicEditor}
                      data={aboutHome}
                      value={inputValueForAdd.aboutHome}
                      onChange={(aboutHomeData, editor) => {
                        setAboutHome(editor.getData());
                        setErrorsForAdd({ ...errorsForAdd, aboutHome: "" });
                      }}
                    />
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["aboutHome"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Select Ameninties
                  </label>

                  <div className="col-lg-9 col-xl-6">
                    <Multiselect
                      options={allAmenities}
                      onSelect={(selectedList, selectedItem) => {
                        setSelectedTopSubjects(selectedList);
                        setErrorsForAdd({
                          ...errorsForAdd,
                          selectedTopSubjects: "",
                        });
                      }}
                      onRemove={(selectedList, removedItem) => {
                        setSelectedTopSubjects(selectedList);
                      }}
                      displayValue="name"
                      selectedValues={allAmenitiesForUpdate}
                    />

                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["selectedTopSubjects"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Crew Contact
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="number"
                        className={`form-control form-control-lg form-control-solid `}
                        id="crewContact"
                        name="crewContact"
                        value={inputValueForAdd.crewContact}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["crewContact"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">
                    Video Of Property
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <div>
                      <input
                        type="text"
                        className={`form-control form-control-lg form-control-solid `}
                        id="propertyVideo"
                        name="propertyVideo"
                        value={inputValueForAdd.propertyVideo}
                        onChange={(e) => {
                          handleOnChnageAdd(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errorsForAdd["propertyVideo"]}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    onClick={(e) => {
                      handelUpdatePropertyDetails(e);
                    }}
                    className="btn btn-success mr-2"
                  >
                    <span>Update Details</span>
                    {loading && (
                      <span className="mx-3 spinner spinner-white"></span>
                    )}
                  </button>
                </div>
              </div>
            ) : null}
          </List>
        </Dialog>
      ) : null}
    </>
  );
};
export default Properties;
